<template>
  <div class='step3'>
    <a-form-model ref='form' :model='model' :rules='validatorRules'>
      <a-form-model-item  prop='elementSource'>
        <a-card size='small' hoverable>
          <div class='header'><b>元素数据源</b><a-button @click='addDataSource("element")' type="primary" size='small' style='float: right'>添加</a-button></div>
          <a-divider style='margin: 12px 0'/>
          <div class='list'>
            <div class='list-item' v-for='(item,index) in dataSource'>
              <a-space :size='12'>
                <span>数据源{{index + 1}}</span>
                <a-select v-model='item.form' placeholder='请选择表单' style='width: 200px'><a-select-option value='test'>测试选项</a-select-option></a-select>
                <a-select v-model='item.element' placeholder='请选择元素' style='width: 200px'><a-select-option value='test'>测试选项1</a-select-option></a-select>
                <span><a-icon type="setting" theme="twoTone" @click='optionMappingSetting(item)' title='选项映射关系配置'/></span>
                <span><a-icon v-if='index > 0' type="close" @click='removeDataSource("element", index)'/></span>
              </a-space>
            </div>
          </div>
        </a-card>
      </a-form-model-item>
    </a-form-model>
    <!--选项映射关系配置-->
    <option-mapping-setting ref='OptionMappingSetting' @ok=''></option-mapping-setting>
  </div>
</template>

<script>
import OptionMappingSetting from '@views/project/setting/formula/OptionMappingSetting'
export default {
  name: 'Step3',
  components: { OptionMappingSetting },
  props: ['model'],
  data() {
    return {
      validatorRules: {},
      dataSource: [{}],
    }
  },
  created() {
  },
  methods: {
    /**
     * 添加数据源
     */
    addDataSource() {
      this.dataSource.push({})
    },
    /**
     * 移除数据源
     * @param index
     */
    removeDataSource(index) {
      this.dataSource.splice(index, 1)
    },
    /**
     * 选项映射关系配置
     */
    optionMappingSetting({form, element}) {
      if (!form) {
        this.$message.warning('数据源表单未选择')
        return
      }
      if (!element) {
        this.$message.warning('数据源元素未选择')
        return
      }
      const findElementObj = [].find(item => item.name === element) || {}
      if (!findElementObj.dictCode) {
        // this.$message.warning('数据源不是选择题')
        // return
        this.$message.warning('待处理: 判断 数据源不是选择题?')
      }
      this.$refs['OptionMappingSetting'].visible = true
    },


    validate() {
      /*简陋验证逻辑,请修改*/
      this.model.elementSource = ''
      this.dataSource.forEach(item => this.model.elementSource += item.element)
      if (!this.model.elementSource) {
        this.$message.warning('数据源未正确选择')
        return false
      }
      return true
    }

  }
}
</script>

<style scoped>
.step3 {
  padding: 0 80px;
}
.header {
  font-size: 16px;
}
.list > .list-item {
  margin: 12px auto;
  width: 900px;
}
</style>
